module.exports = __webpack_public_path__ + "img/product_3.6338132f.png";